import { Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import { Toaster } from 'react-hot-toast'

import Home from './routes/index'
import GameDetail from './routes/games.$gameId'
import TaskDetail from './routes/games.$gameId.tasks.$taskId'
import GameCreate from './routes/games.create'
import TaskCreate from './routes/games.$gameId.tasks.create'
import GitHubCallback from './routes/github-callback'

// New repository-based routes
import GameDetailByRepository from './routes/games.$repositoryName'
import TaskDetailByRepository from './routes/games.$repositoryName.tasks.$issueNumber'

function App() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>    
      <Routes>
        <Route path="*" element={<Navigate to="/" replace />} />
        <Route path="/" element={<Home />} />
        <Route path="/games/create" element={<GameCreate />} />
        
        {/* Repository-based routes (new, more readable URLs) */}
        <Route path="/games/:repositoryName/tasks/:issueNumber" element={<TaskDetailByRepository />} />
        <Route path="/games/:repositoryName" element={<GameDetailByRepository />} />
        
        {/* Legacy ID-based routes (for backward compatibility) */}
        <Route path="/games/:gameId/tasks/create" element={<TaskCreate />} />
        <Route path="/games/:gameId/tasks/:taskId" element={<TaskDetail />} />
        <Route path="/games/:gameId" element={<GameDetail />} />
        
        <Route path="/github-callback" element={<GitHubCallback />} />
      </Routes>
      <Toaster 
        position="bottom-right"
        toastOptions={{
          style: {
            background: '#333',
            color: '#fff',
          },
          success: {
            duration: 3000,
            iconTheme: {
              primary: '#60e25e',
              secondary: '#333',
            },
          },
          error: {
            duration: 4000,
            iconTheme: {
              primary: '#ff4949',
              secondary: '#333',
            },
          },
        }}
      />
    </>
  )
}

export default App
